import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SiteContentContext = createContext(null);

// Fallbacks (kept from original mock in case API fails)
const FALLBACK = {
  heroSlides: [], productCategories: [], productSubcategories: [],
  products: [], newsItems: [],
  partners: [], stats: [], supportItems: [], about: {}, config: {},
};

export const SiteContentProvider = ({ children }) => {
  const [state, setState] = useState({ ...FALLBACK, loaded: false });

  const refresh = useCallback(async () => {
    try {
      const [hero, cats, subs, prods, news, parts, stats, sup, about, cfg] = await Promise.all([
        axios.get(`${API}/content/hero-slides`).then(r => r.data).catch(() => []),
        axios.get(`${API}/content/product-categories`).then(r => r.data).catch(() => []),
        axios.get(`${API}/content/product-subcategories`).then(r => r.data).catch(() => []),
        axios.get(`${API}/content/products`).then(r => r.data).catch(() => []),
        axios.get(`${API}/content/news-items`).then(r => r.data).catch(() => []),
        axios.get(`${API}/content/partners`).then(r => r.data).catch(() => []),
        axios.get(`${API}/content/stats`).then(r => r.data).catch(() => []),
        axios.get(`${API}/content/support-items`).then(r => r.data).catch(() => []),
        axios.get(`${API}/singleton/about-content`).then(r => r.data).catch(() => ({})),
        axios.get(`${API}/singleton/site-config`).then(r => r.data).catch(() => ({})),
      ]);
      setState({
        heroSlides: hero, productCategories: cats, productSubcategories: subs,
        products: prods, newsItems: news,
        partners: parts, stats, supportItems: sup, about, config: cfg, loaded: true,
      });
    } catch (e) {
      setState((s) => ({ ...s, loaded: true }));
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <SiteContentContext.Provider value={{ ...state, refresh }}>
      {children}
    </SiteContentContext.Provider>
  );
};

export const useSiteContent = () => useContext(SiteContentContext);
